import React from "react";
import { Navigate } from "react-router-dom";
import { URL_DASHBOARD, URL_ROOT } from "../constants/urls";
import { ACCESS_LEVEL_AUTH, ACCESS_LEVEL_GUEST } from "../constants/accessLevels";
import { useUser } from "@/contexts/UserContext";

function RegisterRoute({
  accessLevel,
  component: ScreenComponent,
  layout: ScreenLayout,
  layoutParams = {},
}) {
  const { user } = useUser();

  if (accessLevel === ACCESS_LEVEL_GUEST && user) {
    return <Navigate to={URL_DASHBOARD} />;
  }

  if (accessLevel === ACCESS_LEVEL_AUTH && !user) {
    return <Navigate to={URL_ROOT} />;
  }

  const screen = <ScreenComponent />;

  return ScreenLayout ? <ScreenLayout {...layoutParams}>{screen}</ScreenLayout> : screen;
}

export default RegisterRoute;
